import { max, mean, min, sum } from "mathjs";
import { DATA_TYPES, ONE_HOT_MODE } from "../../constants";
import Column from "../../MachineLearning/Column";
import Dataset, { dataSplit } from "../../MachineLearning/Dataset";
import { replaceColumn } from "./calcVariableImportance";

const N_INTERVALS = 10;

export type varImpactType = {
  values: number[][];
  xRange: number[];
};

function getRange(col: Column) {
  let range: number[] = [];
  let rangeNormalized: number[] = [];
  if (col.columnType === DATA_TYPES.number) {
    let minVal = min(col.vectorizedData);
    let maxVal = max(col.vectorizedData);

    let interval = (maxVal - minVal) / (N_INTERVALS - 1);
    range = Array(N_INTERVALS)
      .fill(0)
      .map((v, index) => minVal + interval * index);
    rangeNormalized = Dataset.normalize(range, col.colStats);
  } else if (col.columnType === DATA_TYPES.categorical) {
    range = Array(Column.getNClasses(col))
      .fill(0)
      .map((v, i) => i);
    rangeNormalized = range;
  }
  return { range, rangeNormalized };
}

function getMeanPrediction(
  savedModels: any[],
  data: number[][],
  outCol: Column
) {
  let avg: number[] = Array(Column.getNClasses(outCol)).fill(0);
  for (let model of savedModels) {
    if (outCol.columnType === DATA_TYPES.categorical) {
      let probs = model.predictProbs(data);
      for (let i = 0; i < avg.length; i++) {
        if (i >= probs[0].length) {
          avg[i] = 0;
        } else {
          try {
            avg[i] += mean(probs.map((v) => v[i]));
          } catch {
            let probs = model.predictProbs(data);
          }
        }
      }
    } else if (outCol.columnType === DATA_TYPES.number) {
      let output = model.predict(data);
      output = Dataset.deNormalize(output, outCol.colStats);
      avg[0] += mean(output);
    }
  }

  avg = avg.map((v) => v / savedModels.length);
  return avg;
}

function repaceColValue(data: number[][], value: number, index: number) {
  const arCopy = [...data.map((row) => row[index])];
  for (let i = 0; i < data.length; i++) {
    data[i][index] = value;
  }
  return { data, arCopy };
}

export function calcVariableImpact(
  savedModels: any[],
  trainData: dataSplit,
  importantCols: Column[],
  yCol: Column
) {
  let varImpactMap = {};
  // const outCol = dataset.getColumn(trainData.info.yColumn);
  let X = trainData.X;

  for (let i = 0; i < importantCols.length; i++) {
    let col = importantCols[i];
    let { range, rangeNormalized } = getRange(col);
    let colIndexes = trainData.info.xColIndexes.get(col.columnName);
    let values: number[][] = [];
    for (let val of rangeNormalized) {
      let arrays: number[][] = [];
      if (col.columnType === DATA_TYPES.categorical) {
        for (let k = 0; k < colIndexes.length; k++) {
          const replaceVal = !ONE_HOT_MODE ? val : val === k ? 1 : 0;
          let { data, arCopy } = repaceColValue(X, replaceVal, colIndexes[k]);
          arrays.push(arCopy);
        }
      } else {
        let { data, arCopy } = repaceColValue(X, val, colIndexes[0]);
        arrays.push(arCopy);
      }
      let avg = getMeanPrediction(savedModels, X, yCol);
      values.push(avg);

      // Restore xTrain
      let index = 0;
      for (let j of colIndexes) {
        replaceColumn(X, arrays[index], j);
        index += 1;
      }
    }
    let varImpact: varImpactType = {
      values: values,
      xRange: range,
    };
    varImpactMap[col.columnName] = varImpact;
  }

  // const outCol = dataset.getColumn(trainData.info.yColumn);
  // const colNames = Object.keys(trainData.info.xColIndexes);

  // let varImpactMap: Map<string, varImpactType> = new Map();

  // for (let i = 0; i < allColumns.length; i++) {
  //   let col = dataset.getColumn(allColumns[i]);

  //   let { range, rangeNormalized } = getRange(col);
  //   let values: number[][] = [];
  //   for (let val of rangeNormalized) {
  //     let { data, arCopy } = repaceColValue(trainData.xTrain, val, i);
  //     let avg = getMeanPrediction(savedModels, data, outCol);
  //     values.push(avg);
  //     trainData.xTrain = replaceColumn(data, arCopy, i);
  //   }
  //   let varImpact: varImpactType = {
  //     values: values,
  //     xRange: range,
  //   };
  //   varImpactMap.set(col.columnName, varImpact);
  // }

  return varImpactMap;
}
